import { filterXSS } from 'xss';

export const filterXss = (htmlContent: string) =>
  filterXSS(htmlContent, {
    whiteList: {
      a: ['href', 'target'],
      img: ['src', 'alt', 'width', 'height', 'style', 'loading', 'decoding'],
      span: [],
      div: [],
      p: [],
      td: [],
      th: [],
      h1: [],
      h2: [],
      h3: [],
      h4: [],
      h5: [],
      h6: [],
      b: [],
      strong: [],
      i: [],
      u: [],
      table: [],
      tbody: [],
      thead: [],
      tfoot: [],
      tr: [],
      tt: [],
      ul: [],
      ol: [],
      li: [],
      caption: [],
      figcaption: [],
      figure: [],
      br: [],
      code: [],
      blockquote: [],
      hr: [],
      ins: [],
      em: [],
      del: [],
      pre: [],
    },

    singleQuotedAttributeValue: true,
    allowCommentTag: false,

    css: {
      whiteList: {
        width: true,
        height: true,
      },
    },
  });
